import PropTypes from 'prop-types';

const PayoutType = PropTypes.shape({
  id: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  arrival_date: PropTypes.string,
  created: PropTypes.string,
  balance_transaction: PropTypes.string,
  description: PropTypes.string,
  livemode: PropTypes.bool,
  metadata: PropTypes.shape({}),
  status: PropTypes.string,
  source_type: PropTypes.string,
  destination: PropTypes.shape({
    id: PropTypes.string,
    last4: PropTypes.string,
    object: PropTypes.string,
    bank_name: PropTypes.string
  }),
  currency: PropTypes.string
});

export default PayoutType;
